<template>
  <div class="galeria container">
    <h2 class="text-center shadow-sm border py-2">Galeria</h2>

    <div class="mb-4" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
      <p>Cargando, por favor espera...</p>
    </div>

    <div>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'landing' ? 'success' : 'primary')"
        @click="switchSection('landing')">Landing</button>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'nosotros' ? 'success' : 'primary')"
        @click="switchSection('nosotros')">Nosotros</button>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'experiencias' ? 'success' : 'primary')"
        @click="switchSection('experiencias')">Experiencias</button>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'tarifas' ? 'success' : 'primary')"
        @click="switchSection('tarifas')">Tarifas</button>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'reservas' ? 'success' : 'primary')"
        @click="switchSection('reservas')">Reservas</button>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'traslado' ? 'success' : 'primary')"
        @click="switchSection('traslado')">Traslado</button>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'comoLlegar' ? 'success' : 'primary')"
        @click="switchSection('comoLlegar')">Cómo Llegar</button>
      <button :class="'ms-2 btn btn-' + (selectedSection == 'fotos' ? 'success' : 'primary')"
        @click="switchSection('fotos')">Fotos</button>
      <!--
        <button :class="'ms-2 btn btn-' + (selectedSection == 'videos' ? 'success' : 'primary')"
        @click="switchSection('videos')">Videos</button>
      -->
    </div>

    <div v-if="selectedSection == 'landing'">
      <label>Video URL</label>
      <p>La url del video debe ser como ésta: <br/>Sin ninguna variable extra luego de v=XXX (sin &playList ni nada)<br/>https://www.youtube.com/watch?v=bJAOfwsqSAs</p>
      <div class="input-group mb-3">
        <input class="form-control" v-model="landingVideo" />
        <button class="btn btn-success" @click="variableUpdate('landingVideo', landingVideo)">Actualizar</button>
      </div>
    </div>

    <div v-if="selectedSection == 'fotos'">
      <div class="row mb-4">
        <div class="col-12 col-md-6">
          <div>
            <h2>Subir Fotos</h2>
            <input type="file" @change="handleFileUpload" multiple accept="image/*" class="form-control mb-2" />
            <button @click="uploadPhotos('fotos')" class="btn btn-primary">Subir Fotos</button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <h2 @click="togglePhotos('fotos')" style="cursor: pointer;">
          Fotos <i :class="showPhotosFotos ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showPhotosFotos" class="row">
          <template v-for="photo in photos" :key="photo.id">
            <div v-if="photo.name == 'fotos'" class="col-6 col-md-4 mb-3">
              <div class="card">
                <img :src="photo.url" :alt="photo.original_name" class="card-img-top" />
                <div class="card-body">
                  <a :href="photo.url" target="_blank">{{ photo.url }}</a>
                  <p class="card-text">{{ photo.original_name }}</p>
                  <button @click="deletePhoto(photo.id)" class="btn btn-danger">Eliminar</button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-if="selectedSection == 'reservas'">
      <div class="row mb-4">
        <div class="col-12">
          <h2>Color de Fondo</h2>
          <input class="form-control" disabled v-model="fondoReservas"
            :style="'color: white; border-radius: unset; background: ' + fondoReservas + ';'" />
          <div class="d-flex">
            <input class="form-control" v-model="newFondoReservas"
              :style="'color: white; border-radius: unset; background: ' + newFondoReservas + ';'" />
            <button class="btn btn-success" type="button" style="border-radius: unset;"
              @click="variableUpdate('fondoReservas', this.newFondoReservas)">Guardar</button>
          </div>

          <div>
            <Vue3ColorPicker mode="solid" v-model="newFondoReservas" />
          </div>
        </div>
      </div>

      <div class="row mb-4">
        <div class="col-12 col-md-6">
          <div>
            <h2>Subir Fotos Reservas</h2>
            <input type="file" @change="handleFileUpload" multiple accept="image/*" class="form-control mb-2" />
            <button @click="uploadPhotos('reservas')" class="btn btn-primary">Subir Fotos</button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <h2 @click="togglePhotos('reservas')" style="cursor: pointer;">
          Fotos Reservas <i :class="showPhotosReservas ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showPhotosReservas" class="row">
          <template v-for="photo in photos" :key="photo.id">
            <div v-if="photo.name == 'reservas'" class="col-6 col-md-4 mb-3">
              <div class="card">
                <img :src="photo.url" :alt="photo.original_name" class="card-img-top" />
                <div class="card-body">
                  <a :href="photo.url" target="_blank">{{ photo.url }}</a>
                  <p class="card-text">{{ photo.original_name }}</p>
                  <button @click="deletePhoto(photo.id)" class="btn btn-danger">Eliminar</button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-show="selectedSection == 'traslado'">
      <div class="row mb-4">
        <div class="col-12">
          <h2>Color de Fondo</h2>
          <input class="form-control" disabled v-model="fondoTraslado" style="border-radius: unset;" />
          <div class="d-flex">
            <input class="form-control" v-model="newFondoTraslado" style="border-radius: unset;" />
            <button class="btn btn-success" type="button" style="border-radius: unset;"
              @click="variableUpdate('fondoTraslado', this.newFondoTraslado)">Guardar</button>
          </div>

          <div>
            <Vue3ColorPicker mode="solid" v-model="newFondoTraslado" />
          </div>
        </div>
      </div>
      <div class="my-3">
        <h2>Detalle Traslado</h2>
        <div id="editorTraslado">
          <textarea id="textareaTraslado" v-model="traslado"></textarea>
        </div>
        <button class="btn btn-success float-end my-3" @click="variableUpdate('traslado', this.traslado)">Guardar
          Detalle</button>
        <div style="clear: both;"></div>
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-6">
          <div>
            <h2>Subir Fotos Traslado</h2>
            <input type="file" @change="handleFileUpload" multiple accept="image/*" class="form-control mb-2" />
            <button @click="uploadPhotos('traslado')" class="btn btn-primary">Subir Fotos</button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <h2 @click="togglePhotos('traslado')" style="cursor: pointer;">
          Fotos Traslado <i :class="showPhotosTraslado ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showPhotosTraslado" class="row">
          <template v-for="photo in photos" :key="photo.id">
            <div v-if="photo.name == 'traslado'" class="col-6 col-md-4 mb-3">
              <div class="card">
                <img :src="photo.url" :alt="photo.original_name" class="card-img-top" />
                <div class="card-body">
                  <a :href="photo.url" target="_blank">{{ photo.url }}</a>
                  <p class="card-text">{{ photo.original_name }}</p>
                  <button @click="deletePhoto(photo.id)" class="btn btn-danger">Eliminar</button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-show="selectedSection == 'comoLlegar'">
      <div class="row mb-4">
        <div class="col-12">
          <h2>Color de Fondo</h2>
          <input class="form-control" disabled v-model="fondoComoLlegar" style="border-radius: unset;" />
          <div class="d-flex">
            <input class="form-control" v-model="newFondoComoLlegar" style="border-radius: unset;" />
            <button class="btn btn-success" type="button" style="border-radius: unset;"
              @click="variableUpdate('fondoComoLlegar', this.newFondoComoLlegar)">Guardar</button>
          </div>

          <div>
            <Vue3ColorPicker mode="solid" v-model="newFondoComoLlegar" />
          </div>
        </div>
      </div>
      <div class="my-3">
        <h2>Detalle Cómo Llegar</h2>
        <div id="editorComoLlegar">
          <textarea id="textareaComoLlegar" v-model="comoLlegar"></textarea>
        </div>
        <button class="btn btn-success float-end my-3" @click="variableUpdate('comoLlegar', this.comoLlegar)">Guardar
          Detalle</button>
        <div style="clear: both;"></div>
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-6">
          <div>
            <h2>Subir Fotos Cómo Llegar</h2>
            <input type="file" @change="handleFileUpload" multiple accept="image/*" class="form-control mb-2" />
            <button @click="uploadPhotos('comoLlegar')" class="btn btn-primary">Subir Fotos</button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <h2 @click="togglePhotos('comoLlegar')" style="cursor: pointer;">
          Fotos Cómo Llegar <i :class="showPhotosComoLlegar ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showPhotosComoLlegar" class="row">
          <template v-for="photo in photos" :key="photo.id">
            <div v-if="photo.name == 'comoLlegar'" class="col-6 col-md-4 mb-3">
              <div class="card">
                <img :src="photo.url" :alt="photo.original_name" class="card-img-top" />
                <div class="card-body">
                  <a :href="photo.url" target="_blank">{{ photo.url }}</a>
                  <p class="card-text">{{ photo.original_name }}</p>
                  <button @click="deletePhoto(photo.id)" class="btn btn-danger">Eliminar</button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-show="selectedSection == 'nosotros'">
      <div class="row mb-4">
        <div class="col-12">
          <h2>Color de Fondo</h2>
          <input class="form-control" disabled v-model="fondoNosotros" style="border-radius: unset;" />
          <div class="d-flex">
            <input class="form-control" v-model="newFondoNosotros" style="border-radius: unset;" />
            <button class="btn btn-success" type="button" style="border-radius: unset;"
              @click="variableUpdate('fondoNosotros', this.newFondoNosotros)">Guardar</button>
          </div>

          <div>
            <Vue3ColorPicker mode="solid" v-model="newFondoNosotros" />
          </div>
          <!--
          <div class="input-group mb-3" style="width: 250px;">
            <input type="text" class="form-control" v-model="fondoNosotros">
            <button class="btn btn-outline-secondary" type="button"
              @click="variableUpdate('fondoNosotros', this.fondoNosotros)">Guardar</button>
          </div>
          -->
        </div>
      </div>
      <div class="my-3">
        <h2>Detalle Nosotros</h2>


        <div id="editorNosotros">
          <textarea id="textareaNosotros"></textarea>
        </div>

        <button class="btn btn-success float-end my-3" @click="variableUpdate('nosotros', this.nosotros)">
          Guardar Detalle
        </button>
        <div style="clear: both;"></div>
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-6">
          <div>
            <h2>Subir Fotos Nosotros</h2>
            <input type="file" @change="handleFileUpload" multiple accept="image/*" class="form-control mb-2" />
            <button @click="uploadPhotos('nosotros')" class="btn btn-primary">Subir Fotos</button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <h2 @click="togglePhotos('nosotros')" style="cursor: pointer;">
          Fotos Nosotros <i :class="showPhotosNosotros ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showPhotosNosotros" class="row">
          <template v-for="photo in photos" :key="photo.id">
            <div v-if="photo.name == 'nosotros'" class="col-6 col-md-4 mb-3">
              <div class="card">
                <img :src="photo.url" :alt="photo.original_name" class="card-img-top" />
                <div class="card-body">
                  <a :href="photo.url" target="_blank">{{ photo.url }}</a>
                  <p class="card-text">{{ photo.original_name }}</p>
                  <button @click="deletePhoto(photo.id)" class="btn btn-danger">Eliminar</button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-show="selectedSection == 'experiencias'">
      <div class="row mb-4">
        <div class="col-12">
          <h2>Color de Fondo</h2>
          <input class="form-control" disabled v-model="fondoExperiencias" style="border-radius: unset;" />
          <div class="d-flex">
            <input class="form-control" v-model="newFondoExperiencias" style="border-radius: unset;" />
            <button class="btn btn-success" type="button" style="border-radius: unset;"
              @click="variableUpdate('fondoExperiencias', this.newFondoExperiencias)">Guardar</button>
          </div>

          <div>
            <Vue3ColorPicker mode="solid" v-model="newFondoExperiencias" />
          </div>

          <!--
          <div class="input-group mb-3" style="width: 250px;">
            <input type="text" class="form-control" v-model="fondoExperiencias">
            <button class="btn btn-outline-secondary" type="button"
              @click="variableUpdate('fondoExperiencias', this.fondoExperiencias)">Guardar</button>
          </div>
          -->
        </div>
      </div>
      <div class="my-3">
        <h2>Detalle Experiencias</h2>
        <div id="editorExperiencias">
          <textarea id="textareaExperiencias" v-model="experiencias"></textarea>
        </div>

        <button class="btn btn-success float-end my-3" @click="variableUpdate('experiencias', this.experiencias)">
          Guardar Detalle
        </button>
        <div style="clear: both;"></div>
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-6">
          <div>
            <h2>Subir Fotos Experiencias</h2>
            <input type="file" @change="handleFileUpload" multiple accept="image/*" class="form-control mb-2" />
            <button @click="uploadPhotos('experiencias')" class="btn btn-primary">Subir Fotos</button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <h2 @click="togglePhotos('experiencias')" style="cursor: pointer;">
          Fotos Experiencias <i :class="showPhotosExperiencias ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showPhotosExperiencias" class="row">
          <template v-for="photo in photos" :key="photo.id">
            <div v-if="photo.name == 'experiencias'" class="col-6 col-md-4 mb-3">
              <div class="card">
                <img :src="photo.url" :alt="photo.original_name" class="card-img-top" />
                <div class="card-body">
                  <a :href="photo.url" target="_blank">{{ photo.url }}</a>
                  <p class="card-text">{{ photo.original_name }}</p>
                  <button @click="deletePhoto(photo.id)" class="btn btn-danger">Eliminar</button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-show="selectedSection == 'tarifas'">
      <div class="row mb-4">
        <div class="col-12">
          <h2>Color de Fondo</h2>
          <input class="form-control" disabled v-model="fondoTarifas" style="border-radius: unset;" />
          <div class="d-flex">
            <input class="form-control" v-model="newFondoTarifas" style="border-radius: unset;" />
            <button class="btn btn-success" type="button" style="border-radius: unset;"
              @click="variableUpdate('fondoTarifas', this.newFondoTarifas)">Guardar</button>
          </div>

          <div>
            <Vue3ColorPicker mode="solid" v-model="newFondoTarifas" />
          </div>
        </div>
      </div>
      <div class="my-3">
        <h2>Detalle Tarifas</h2>
        <div id="editorTarifas">
          <textarea id="textareaTarifas" v-model="tarifas"></textarea>
        </div>
        <button class="btn btn-success float-end my-3" @click="variableUpdate('tarifas', this.tarifas)">
          Guardar Detalle
        </button>
        <div style="clear: both;"></div>
      </div>
      <div class="row mb-4">
        <div class="col-12 col-md-6">
          <div>
            <h2>Subir Fotos Tarifas</h2>
            <input type="file" @change="handleFileUpload" multiple accept="image/*" class="form-control mb-2" />
            <button @click="uploadPhotos('tarifas')" class="btn btn-primary">Subir Fotos</button>
          </div>
        </div>
      </div>

      <div class="mb-4">
        <h2 @click="togglePhotos('tarifas')" style="cursor: pointer;">
          Fotos Tarifas <i :class="showPhotosTarifas ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showPhotosTarifas" class="row">
          <template v-for="photo in photos" :key="photo.id">
            <div v-if="photo.name == 'tarifas'" class="col-6 col-md-4 mb-3">
              <div class="card">
                <img :src="photo.url" :alt="photo.original_name" class="card-img-top" />
                <div class="card-body">
                  <a :href="photo.url" target="_blank">{{ photo.url }}</a>
                  <p class="card-text">{{ photo.original_name }}</p>
                  <button @click="deletePhoto(photo.id)" class="btn btn-danger">Eliminar</button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div v-if="selectedSection == 'videos'">
      <div class="row">
        <div class="col-12 col-md-6">
          <h2>Subir Video</h2>
          <input type="file" @change="handleVideoUpload" accept="video/*" class="form-control mb-2" />
          <button @click="uploadVideo" class="btn btn-primary">Subir Video</button>
        </div>
      </div>
      <div class="mb-4">
        <h2 @click="toggleVideos" style="cursor: pointer;">
          Videos <i :class="showVideos ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
        </h2>
        <div v-if="showVideos" class="row">
          <div class="col-6 col-md-4 mb-3" v-for="video in videos" :key="video.id">
            <div class="card">
              <video controls class="card-img-top">
                <source :src="video.url" />
                Tu navegador no soporta el elemento de video.
              </video>
              <div class="card-body">
                <a :href="video.url" target="_blank">{{ video.url }}</a>
                <p class="card-text">{{ video.original_name }}</p>
                <button @click="deleteVideo(video.id)" class="btn btn-danger">Eliminar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { useToast } from 'vue-toastification';
const toast = useToast();

import { Vue3ColorPicker } from '@cyhnkckali/vue3-color-picker';

export default {
  name: 'ViewAdminGaleria',
  components: {
    Vue3ColorPicker
  },
  data() {
    return {
      selectedSection: 'landing',

      selectedPhotos: null,
      selectedVideo: null,

      photos: [],
      videos: [],

      showVideos: false,

      loading: false,

      showPhotosFotos: false,
      showPhotosReservas: false,
      showPhotosTraslado: false,
      showPhotosComoLlegar: false,
      showPhotosNosotros: false,
      showPhotosExperiencias: false,
      showPhotosTarifas: false,

      fondoReservas: '',
      newFondoReservas: '',
      fondoTraslado: '',
      newFondoTraslado: '',
      fondoComoLlegar: '',
      newFondoComoLlegar: '',
      fondoNosotros: '',
      newFondoNosotros: '',
      fondoExperiencias: '',
      newFondoExperiencias: '',
      fondoTarifas: '',
      newFondoTarifas: '',

      inputTypeReservas: '',
      inputTypeTraslado: '',
      inputTypeComoLlegar: '',
      inputTypeNosotros: '',
      inputTypeExperiencias: '',
      inputTypeTarifas: '',

      traslado: '',
      comoLlegar: '',
      nosotros: '',
      experiencias: '',
      tarifas: '',

      value: '',
      landingVideo: ''
    };
  },
  computed: {
    realFondoNosotros() {
      return this.newFondoNosotros ? this.newFondoNosotros : this.fondoNosotros;
    },
    realFondoExperiencias() {
      return this.newFondoExperiencias ? this.newFondoExperiencias : this.fondoExperiencias;
    },
    realFondoTarifas() {
      return this.newFondoTarifas ? this.newFondoTarifas : this.fondoTarifas;
    },
    realFondoTraslado() {
      return this.newFondoTraslado ? this.newFondoTraslado : this.fondoTraslado;
    },
    realFondoComoLlegar() {
      return this.newFondoComoLlegar ? this.newFondoComoLlegar : this.fondoComoLlegar;
    },
  },
  mounted() {
    // Cargar TinyMCE desde el archivo .js externo
    
    this.galeriaGetPhotos();
    this.galeriaGetVideoNames();
    window.addEventListener('beforeunload', this.handleBeforeUnload);

    this.variableGetByName('fondoTraslado');
    this.variableGetByName('fondoReservas');
    this.variableGetByName('fondoComoLlegar');
    this.variableGetByName('fondoNosotros');
    this.variableGetByName('fondoExperiencias');
    this.variableGetByName('fondoTarifas');
    this.variableGetByName('landingVideo');

    let self = this;
    this.variableGetByName('traslado').then(() => {
      $('#textareaTarslado').html(this.traslado);
      tinymce.init({
        selector: "#textareaTraslado",
        license_key: "gpl",
        setup: (editor) => {
          editor.on("change", () => {
            self.traslado = editor.getContent();
          });          
        },
      });
    });
    this.variableGetByName('comoLlegar').then(() => {
      $('#textareaComoLlegar').html(this.comoLlegar);
      tinymce.init({
        selector: "#textareaComoLlegar",
        license_key: "gpl",
        setup: (editor) => {
          editor.on("change", () => {
            self.comoLlegar = editor.getContent();
          });          
        },
      });
    });
    this.variableGetByName('nosotros').then(() => {
      $('#textareaNosotros').html(this.nosotros);
      tinymce.init({
        selector: "#textareaNosotros",
        license_key: "gpl",
        setup: (editor) => {
          editor.on("change", () => {
            self.nosotros = editor.getContent();
          });          
        },
      });
    });
    this.variableGetByName('experiencias').then(() => {
      $('#textareaExperiencias').html(this.tarifas);
      tinymce.init({
        selector: "#textareaExperiencias",
        license_key: "gpl",
        setup: (editor) => {
          editor.on("change", () => {
            self.experiencias = editor.getContent();
          });          
        },
      });
    });
    this.variableGetByName('tarifas').then(() => {
      $('#textareaTarifas').html(this.tarifas);
      tinymce.init({
        selector: "#textareaTarifas",
        license_key: "gpl",
        setup: (editor) => {
          editor.on("change", () => {
            self.tarifas = editor.getContent();
          });          
        },
      });
    });
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    ...mapActions('galeria', [
      'galeria_uploadPhotos',
      'galeria_uploadVideo',
      'galeria_getPhotos',
      'galeria_getVideoNames',
      'galeria_deletePhoto',
      'galeria_deleteVideo',
      'galeria_getTraslado',
      'galeria_updateTraslado'
    ]),
    ...mapActions('variable', ['variable_update', 'variable_getByName']),
    handleBeforeUnload(event) {
      if (this.loading) {
        const confirmationMessage = 'Hay una carga en proceso. ¿Seguro que deseas salir?';
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    },
    handleFileUpload(event) {
      this.selectedPhotos = event.target.files;
    },
    handleVideoUpload(event) {
      this.selectedVideo = event.target.files[0];
    },
    async uploadPhotos(name) {
      if (!this.selectedPhotos || this.selectedPhotos.length === 0) {
        toast.error('Por favor, selecciona al menos una foto.');
        return;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append('name', name);
      for (let i = 0; i < this.selectedPhotos.length; i++) {
        formData.append('photos[]', this.selectedPhotos[i]);
      }
      try {
        const response = await this.galeria_uploadPhotos(formData);

        if (response.status == 201) {
          await this.galeriaGetPhotos();
          toast.success('Fotos subidas con éxito');
        }
      } catch (error) {
        console.log(error);
        toast.error('Error al subir las fotos');
      } finally {
        this.loading = false;
      }
    },
    async uploadVideo() {
      if (!this.selectedVideo) {
        toast.error('Por favor, selecciona un video.');
        return;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append('video', this.selectedVideo);
      try {
        const response = await this.galeria_uploadVideo(formData);
        if (response.status == 201) {
          await this.galeriaGetVideoNames();
          toast.success('Video subido con éxito');
        }
      } catch (error) {
        console.log(error);
        toast.error('Error al subir el video');
      } finally {
        this.loading = false;
      }
    },
    async galeriaGetPhotos() {
      try {
        const response = await this.galeria_getPhotos({ name: 'todas' });
        this.photos = response.data;
      } catch (error) {
        console.log(error);
        toast.error('Error al obtener las fotos');
      }
    },
    async galeriaGetVideoNames() {
      try {
        const response = await this.galeria_getVideoNames();
        this.videos = response.data;
      } catch (error) {
        console.log(error);
        toast.error('Error al obtener los videos');
      }
    },
    async deletePhoto(id) {
      const confirmDelete = confirm('¿Estás seguro de que deseas eliminar esta foto?');
      if (confirmDelete) {
        try {
          await this.galeria_deletePhoto(id);
          this.galeriaGetPhotos();
          toast.success('Foto eliminada con éxito.');
        } catch (error) {
          console.log(error);
          toast.error('Error al eliminar la foto');
        }
      }
    },
    async deleteVideo(id) {
      const confirmDelete = confirm('¿Estás seguro de que deseas eliminar este video?');
      if (confirmDelete) {
        try {
          await this.galeria_deleteVideo(id);
          this.galeriaGetVideoNames();
          toast.success('Video eliminado con éxito.');
        } catch (error) {
          console.log(error);
          toast.error('Error al eliminar el video');
        }
      }
    },
    togglePhotos(name) {
      if (name == 'reservas') {
        this.showPhotosReservas = !this.showPhotosReservas;
      }
      if (name == 'traslado') {
        this.showPhotosTraslado = !this.showPhotosTraslado;
      }
      if (name == 'comoLlegar') {
        this.showPhotosComoLlegar = !this.showPhotosComoLlegar;
      }
      if (name == 'nosotros') {
        this.showPhotosNosotros = !this.showPhotosNosotros;
      }
      if (name == 'experiencias') {
        this.showPhotosExperiencias = !this.showPhotosExperiencias;
      }
      if (name == 'tarifas') {
        this.showPhotosTarifas = !this.showPhotosTarifas;
      }
      if (name == 'fotos') {
        this.showPhotosFotos = !this.showPhotosFotos;
      }
    },
    toggleVideos() {
      this.showVideos = !this.showVideos;
    },
    switchSection(name) {
      this.selectedSection = name;
      this.selectedPhotos = [];
    },
    async variableUpdate(nombre, value) {
      try {

        let response = await this.variable_update({ nombre: nombre, value: value });

        if (response.status == 200) {
          toast.success("Variable actualizada conn éxito");
        }

      } catch (error) {
        console.log(error);
        toast.error('Error actualizando variable');
      }
    },
    async variableGetByName(nombre) {
      try {
        let response = await this.variable_getByName({ nombre: nombre });

        if (response.status == 200) {
          this[nombre] = response.data.value;
        }

      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo variable');
      }
    }

  },
};
</script>

<style scoped>
.galeria {
  padding: 20px;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.ck-cp-container {
  border-radius: unset !important;
  border: 1px gray solid !important;
  box-shadow: unset !important;
}
</style>
<style>
#editorNosotros .tox-edit-area__iframe {
  background: v-bind(realFondoNosotros) !important;
}

#editorExperiencias .tox-edit-area__iframe {
  background: v-bind(realFondoExperiencias) !important;
}

#editorTarifas .tox-edit-area__iframe {
  background: v-bind(realFondoTarifas) !important;
}

#editorTraslado .tox-edit-area__iframe {
  background: v-bind(realFondoTraslado) !important;
}

#editorComoLlegar .tox-edit-area__iframe {
  background: v-bind(realFondoComoLlegar) !important;
}
</style>
